module.exports = __webpack_public_path__ + "static/media/newOrder.7c71b461.mp3";